module.exports = __webpack_public_path__ + "img/EP18_logo.98cbe85b.png";